import { coordsToKey } from "./coordsToKey";

/**
 * Рассчитывает ВСЕ гексы которые пересекает прямая линия между двумя точками
 * Использует алгоритм 6 направлений с проверкой соседних ячеек
 * Включает также ячейки по которым линия проходит по касательной
 * @param {number} startQ - Q координата начала
 * @param {number} startR - R координата начала
 * @param {number} endQ - Q координата конца
 * @param {number} endR - R координата конца
 * @returns {Array<string>} массив hexKey всех гексов на линии включая касательные
 */
export const getHexesOnLine = (startQ, startR, endQ, endR) => {
  const hexes = [];
  
  const N = Math.max(
    Math.abs(startQ - endQ),
    Math.abs(startR - endR),
    Math.abs((-startQ - startR) - (-endQ - endR))
  );

  for (let i = 0; i <= N; i++) {
    // Основная точка на линии
    const t = i / N;
    const q1 = startQ + (endQ - startQ) * t;
    const r1 = startR + (endR - startR) * t;
    
    // Добавляем смещения для охвата касательных пересечений
    const offsets = [
      [0, 0],
      [0.001, 0],
      [-0.001, 0],
      [0, 0.001],
      [0, -0.001],
      [0.0005, 0.0005],
      [-0.0005, -0.0005],
    ];
    
    offsets.forEach(([dq, dr]) => {
      const q = q1 + dq;
      const r = r1 + dr;
      const s = -q - r;
      
      let rq = Math.round(q);
      let rr = Math.round(r);
      let rs = Math.round(s);
      
      const qDiff = Math.abs(rq - q);
      const rDiff = Math.abs(rr - r);
      const sDiff = Math.abs(rs - s);
      
      if (qDiff > rDiff && qDiff > sDiff) {
        rq = -rr - rs;
      } else if (rDiff > sDiff) {
        rr = -rq - rs;
      }
      
      const key = coordsToKey(rq, rr);
      if (!hexes.includes(key)) {
        hexes.push(key);
      }
    });
  }

  return hexes;
};
